













import * as toastr from "toastr";
import { Component, Vue } from "vue-property-decorator";
import { AppContainer, TYPES } from "@/app/index";
import { SecurityService } from '@/services';

@Component({
})
export default class Home extends Vue {

  // private securityService: SecurityService = AppContainer.get<SecurityService>(TYPES.Services.SecurityService);

  public created(): void {
    // y
  }
}
